import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import { default as List, default as MenuList } from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { bindActionCreators } from "redux";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import Button from "@material-ui/core/Button";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";

import loader from "Assets/Gif/loader.gif";
import { Link } from "react-router-dom";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import starIcon from "Assets/newicons/notify/star/glyph/star-glyph-16px-grey.svg";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import headersList from "Constants/headersList";
import { Helmet } from "react-helmet";
import independenticon from "Assets/Icons/Actions/man-independent-outline-16-px.svg";
import teamicon from "Assets/Icons/Actions/team-outline-16-px.svg";
import salaryIcon from "Assets/newicons/finance/salary/outline/salary-outline-16px.svg";
import addPlusIcon from "Assets/newicons/action/add-plus/outline/add-plus-outline-16px-blue.svg";
import priorityHighIcon from "Assets/newicons/notify/priority/glyph/priority-high-glyph-16-px.svg";
import priorityLowIcon from "Assets/newicons/notify/priority/glyph/priority-low-glyph-16-px.svg";
import priorityMedIcon from "Assets/newicons/notify/priority/glyph/priority-med-glyph-16-px.svg";
import documentIcon from "Assets/newicons/document/document/outline/document-outline-16px.svg";
import copyIcon from "Assets/newicons/action/copy/outline/copy-outline-16-px.svg";
import newsLetterIcon from "Assets/newicons/user-interface/newletter/outline/newsletter-outline-16px.svg";
import moveIcon from "Assets/newicons/action/move/outline/move-outline-16px.svg";
import dependentIcon from "Assets/newicons/app/profile/glyph/dependents-glyph-16px.svg";
import downArrow from "Assets/newicons/arrow/chevron/down/outline/chevron-down-outline-16px.svg";
import rightArrow from "Assets/newicons/arrow/chevron/right/outline/chevron-right-outline-16px.svg";
import designationIcon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import activityIcon from "Assets/newicons/user-interface/activity/outline/activity-outline-16px.svg";
import calenderIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import previewIcon from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";
import kebabIcon from "Assets/newicons/user-interface/kebab/glyph/kebab-glyph-16px.svg";
import userIcon from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import favblackIcon from "Assets/newicons/action/favorite/glyph/favorite-glyph-red-16px.svg";
import favOutline from "Assets/newicons/action/favorite/outline/favorite-outline-16px.svg";
import menuicon from "Assets/Svg/hamburger-menu-outline-16px.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import DrawerHeader from "Component/Headers/drawerHeader";
import IconLabel from "Component/Labels/IconLabel";
import SearchSq from "Component/Material-ui/SearchSq";
import ScheduleActivityDrawer from "Module/Subscription/Recruit/ScheduleActivityDrawer";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import CandidateDetails from "./CandidateDetails";
import Addapplication from "./Addapplication";
import "./index.scss";
import Uploadapplication from "./Uploadapplication";
import { instance } from "Actions/AxiosInstance";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Activity from "./Activity";
import { getFormattedImageLink } from "Utils";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

const initialData = {
  tasks: {
    "task-1": { id: "task-1", content: "Take out the garbage" },
    "task-2": { id: "task-2", content: "Watch my favorite show" },
    "task-3": { id: "task-3", content: "Charge my phone" },
    "task-4": { id: "task-4", content: "Cook dinner" },
  },
  columns: {
    "column-1": {
      id: "column-1",
      title: "To do",
      taskIds: ["task-1", "task-2", "task-3", "task-4"],
    },
    "column-2": {
      id: "column-2",
      title: "In progress",
      taskIds: [],
    },
    "column-3": {
      id: "column-3",
      title: "Done",
      taskIds: [],
    },
  },
  // Facilitate reordering of the columns
  columnOrder: ["column-1", "column-2", "column-3"],
};

const Container = styled.div`
  display: flex;
`;

const eventtype = [
  {
    displayvalue: 1,
    displayname: "Telephonic interview",
  },
  {
    displayvalue: 2,
    displayname: "Face to face interview",
  },
  {
    displayvalue: 3,
    displayname: "Task",
  },
];

const COMPONENT_CONTEXT = {
  PARENT: 1,
  CHILD: 2,
};

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      pageloading: true,
      sortmenu: false,
      sort_anchorEl: null,
      moreOptions: false,
      moreOptions_anchorEl: null,
      selectedPipelineName: [],
      menuOptions: false,
      menuOptions_anchorEl: null,
      activityFlag: false,
      activity_anchorEl: null,
      addclick: false,
      add_anchorEl: null,
      open: false,
      anchorEl: null,
      drawerOpen: false,
      checked: false,
      eventTypeId: "",
      eventTitle: "",
      description: "",
      isSingle: false,
      isBulk: false,
      activitystartdate: "",
      activityduedate: "",
      guestmessage: "",
      candidatemessage: "",
      candidateid: null,
      candidatename: null,
      candidateempid: null,
      pipelinestageid: null,
      stagename: null,
      isfavorite: false,
      viewDetails: false,
      viewResume: false,
      viewCoverLetter: false,
      right: false,
      selectedrow: null,
      showPipelineBoard: true,
      progress: 10,
      carddata: null,
      previouscard: null,
      pipelinestagelist: [],
      jobTemplates: [],
      backupList: [],
      searchValue: "",
      candidateList: [],
      arrFileToDelete: [],
    };
    this.onSortMenuClick = this.onSortMenuClick.bind(this);
    this.openActivity = this.openActivity.bind(this);
    this.moreOptionsClick = this.moreOptionsClick.bind(this);
    this.menuOptionsClick = this.menuOptionsClick.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.backtomainPage = this.backtomainPage.bind(this);
    this.markandunmarkFav = this.markandunmarkFav.bind(this);
    this.getPipelineList = this.getPipelineList.bind(this);
    this.CloseDrawer = this.CloseDrawer.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    // this.getJobTemplate = this.getJobTemplate.bind(this);
  }

  toggleDrawer = (side, open, flag) => () => {
    if (flag === "isSingle") {
      this.setState({
        isSingle: true,
        isBulk: false,
        [side]: open,
      });
    } else if (flag === "isBulk") {
      this.setState({
        isSingle: false,
        isBulk: true,
        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        [side]: open,
      });
    }
    this.setState({
      addclick: false,
    });
  };

  setDeleteFile(arrFileToDelete = []) {
    this.setState({ arrFileToDelete });
  }

  CloseDrawer(intContextKey = null) {
    if (intContextKey == COMPONENT_CONTEXT.PARENT && this.state.isBulk) {
      this.setState({ right: false }, () => this.deleteUnsedDocFile());
    } else {
      this.setState({
        right: false,
      });
    }
  }

  deleteUnsedDocFile() {
    const arrFileToDelete = [...this.state.arrFileToDelete];

    if (arrFileToDelete.length > 0) {
      instance
        .post(`recruit/deleteunusedbulkfile`, { deletefiles: arrFileToDelete })
        .then((result) => {})
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  onAddClick(event, item) {
    this.setState({
      addclick: !this.state.addclick,
      add_anchorEl: event.currentTarget,
      pipelinestageid: item.pipelinestageid,
    });
  }

  SelectHireDate(args) {
    const date = this.ConvertDate(args.value);
    const hiredate = date;
    this.setState({ hiredate });
  }

  onSortMenuClick(event) {
    this.setState(
      {
        sortmenu: !this.state.sortmenu,
        sort_anchorEl: event.currentTarget,
      },
      // () => this.getPipelineList(),
    );
  }

  Sortable = (objData, key, type) => {
    if (type == "desc") {
      console.log("dec");
      // objData.data.sort((a, b) => {
      //   if (a[key] < b[key]) {
      //     return -1;
      //   }
      //   if (a[key] > b[key]) {
      //     return 1;
      //   }
      //   return 0;
      // });
      objData.data.sort((a, b) => b[key].localeCompare(a[key]));
    } else {
      console.log("acs");
      objData.data.sort((a, b) => a[key].localeCompare(b[key]));
    }

    const { pipelineList } = this.state;
    const index = pipelineList.findIndex(
      (x) => x.pipelinestageid == objData.pipelinestageid,
    );
    if (index !== -1) {
      // pipelineList[index].hidden = true;
      this.setState({
        pipelineList,
        anchorEl: null,
        open: false,
        menuOptions: false,
      });
    }
  };

  hideStage = () => {
    const { pipelineList, selectedpipelinestage } = this.state;
    const index = pipelineList.findIndex(
      (x) => x.pipelinestageid == selectedpipelinestage.pipelinestageid,
    );
    if (index !== -1) {
      pipelineList[index].hidden = true;
      this.setState({ pipelineList, menuOptions: false });
    }
  };

  openActivity(event, data) {
    // let arrResult = instance.get(`recruit/getcandidateactivity/${data.candidateid}`);
    this.getCandidateActivity(event, data);
    event.stopPropagation();
  }

  getCandidateActivity = (event, data) => {
    instance
      .get(`recruit/getcandidateactivity/${data.candidateid}`)
      .then((result) => {
        this.setState({
          activityFlag: !this.state.activityFlag,
          activityList: result.data.result,
          activity_anchorEl: event.currentTarget,
          selectedCandidate: data,
          moreOptions: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  closeActivity = () => {
    this.setState({
      activityFlag: false,
    });
  };

  handleChange(value, key) {
    this.setState({
      [key]: value,
    });
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: !this.state.open,
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, open: false, menuOptions: false });
  };

  moreOptionsClick(event, item, pipelinestageid1) {
    this.setState({
      moreOptions: !this.state.moreOptions,
      moreOptions_anchorEl: event.currentTarget,
      selectedrow: item,
      pipelinestageid: pipelinestageid1,
    });
    event.stopPropagation();
  }

  menuOptionsClick(event, item) {
    this.setState({
      menuOptions: !this.state.menuOptions,
      menuOptions_anchorEl: event.currentTarget,
      selectedpipelinestage: item,
    });
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  componentDidMount() {
    if (
      this.props.isrecruiter ||
      this.props.ishiringowner ||
      this.props.ishiringmanager
    ) {
      setTimeout(() => {
        this.getPipelineList();
      }, 250);
      const pipelinename =
        this.state.selectedPipelineName &&
        this.state.selectedPipelineName.filter(
          (x) => x.displayvalue == this.state.tabpipelineid,
        );
      this.setState({ pipelinename });

      if (window.location.pathname.includes("app/recruit/pipeline/")) {
        this.getData(null, true);
      }
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {}

  handleSearch(e) {
    const { candidateList, pipelinestagelist } = this.state;

    const arrFilterCandidateList = e.target.value
      ? candidateList.filter(
          (objCandidate) =>
            objCandidate.name
              .toLowerCase()
              .search(e.target.value.toLowerCase()) != -1 ||
            objCandidate.designationname
              .toLowerCase()
              .search(e.target.value.toLowerCase()) != -1,
        )
      : candidateList;

    const arrPipelineList =
      (arrFilterCandidateList.length > 0 &&
        pipelinestagelist.map((element) => {
          element.hidden = false;
          if (
            [5, 6].some((intStgCtg) => intStgCtg == element.stagecategoryid)
          ) {
            element.hidden = true;
          }
          element.data = arrFilterCandidateList.filter(
            (x) =>
              x.pipelinestageid == element.displayvalue ||
              (element.stagecategoryid == 1 && x.candidatestageid == null),
          );
          element.count = element.data.length;
          return element;
        })) ||
      pipelinestagelist.map((element) => {
        element.count = 0;
        element.hidden = false;
        if ([5, 6].some((intStgCtg) => intStgCtg == element.stagecategoryid)) {
          element.hidden = true;
        }
        return element;
      });

    this.setState({
      searchValue: e.target.value,
      pipelineList: arrPipelineList,
    });
  }

  onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const start = this.state.columns[source.droppableId];
    const finish = this.state.columns[destination.droppableId];

    if (start === finish) {
      const newTaskIds = Array.from(start.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...start,
        taskIds: newTaskIds,
      };

      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [newColumn.id]: newColumn,
        },
      };

      this.setState(newState);
      return;
    }

    // Moving from one list to another
    const startTaskIds = Array.from(start.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds,
    };

    const finishTaskIds = Array.from(finish.taskIds);
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds,
    };

    const newState = {
      ...this.state,
      columns: {
        ...this.state.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    };
    this.setState(newState);
  };

  getPipelineList() {
    instance
      .get(
        `recruit/getpipelinelist/${this.props.isrecruiter}/${this.props.ishiringowner}/${this.props.ishiringmanager}/${this.props.isparticipant}`,
      )
      .then((result) => {
        if (this.state.tabpipelineid) {
          const selectedPipelineName =
            result.data.result &&
            result.data.result.filter(
              (x) =>
                x.displayvalue == this.state.tabpipelineid &&
                this.state.tabpipelineid,
            );
          this.setState({ selectedPipelineName });
        }
        this.setState({
          hiringPipelines: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  // getActivityInit = () => {
  //   instance
  //     .get("recruit/initactivity")
  //     .then((result) => {
  //       this.setState({
  //         employeeList: result.data.result[0] && result.data.result[0].employee,
  //         alltimezone:
  //           result.data.result[0] && result.data.result[0].alltimezone,
  //       });
  //     })
  //     .catch((error) => {
  //       this.props.enqueueSnackbar(
  //         error.response ? error.response.data.error.message : error.message,
  //         { variant: "error" },
  //       );
  //     });
  // };

  markandunmarkFav() {
    const { selectedrow, carddata } = this.state;
    // console.log('selectedrow: ', selectedrow);
    const data = {
      candidateid: selectedrow.candidateid,
      isfavorite: !selectedrow.isfavorite,
      candidatefavoriteid: selectedrow.candidatefavoriteid,
      pipelinestageid: this.state.pipelinestageid,
    };
    const URL = `recruit/markunmarkfavorite`;
    this.setState({
      isDisableSaveButton: true,
    });
    instance
      .post(URL, data)
      .then((result) => {
        this.getData(carddata, true);
        this.setState({
          moreOptions: false,
          moreOptions_anchorEl: null,
          isDisableSaveButton: false,
        });
        //   this.props.enqueueSnackbar("Saved successfully", { variant: 'success' });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({
          isDisableSaveButton: false,
        });
      });
  }

  onDrag = (param) => {
    const pipelineList = [...this.state.pipelineList];

    const tempArr = param.draggableId.split("_");
    if (
      tempArr.length != 3 ||
      !param.destination ||
      param.destination.droppableId == param.source.droppableId
    ) {
      return;
    }

    const intCandidateId = tempArr[2];
    const tempDestinationArr = param.destination.droppableId.split("_");
    const intDestinationIndex = tempDestinationArr[1];
    const strDestinationStage = pipelineList[intDestinationIndex].stagename;

    const intPipelineStageid = tempDestinationArr[2];
    const intCandidateName = tempArr[0];

    const tempSourceArr = param.source.droppableId.split("_");
    const intSourceIndex = tempSourceArr[1];
    const strSourceStage = pipelineList[intSourceIndex].stagename;
    const newData = pipelineList[intSourceIndex].data.splice(
      param.source.index,
      1,
    );

    pipelineList[intDestinationIndex].data.splice(0, 0, newData[0]);

    this.changeCandidateStage(
      intCandidateId,
      intPipelineStageid,
      (newData[0] && newData[0].candidatestageid) || null,
      intCandidateName,
      strSourceStage,
      strDestinationStage,
    );
  };

  changeCandidateStage = (
    intCandidateid,
    intPipelineStageid,
    intCandidateStageid,
    intCandidateName,
    strSourceStage,
    strDestinationStage,
  ) => {
    const data = {
      candidateid: intCandidateid,
      pipelinestageid: intPipelineStageid,
      candidatestageid: intCandidateStageid,
      isonlynotify: false,
    };

    this.props.enqueueSnackbar(
      `You are moving ${intCandidateName} from ${strSourceStage} to ${strDestinationStage} stage`,
      {
        persist: true,
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              instance
                .post(`recruit/insertupdatecandidatestage`, {
                  ...data,
                  isonlynotify: true,
                })
                .then(() => {
                  this.getData(this.state.carddata, true);
                })
                .catch((error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                });
            }}
          >
            Notify & move
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              instance
                .post(`recruit/insertupdatecandidatestage`, data)
                .then(() => {
                  this.getData(this.state.carddata, true);
                })
                .catch((error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                });
            }}
          >
            Only move
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              this.getData(this.state.carddata, true);
            }}
          >
            Cancel
          </Button>,
        ],
      },
    );
  };

  // onSave() {
  //   const { activityList } = this.state;
  //   const data = activityList.filter((x) => x.checked);
  //   this.props.enqueueSnackbar(
  //     "You are moving Kushalraj from Stage A to Stage B",
  //     {
  //       variant: "warning",
  //       action: [
  //         <Button
  //           key="key"
  //           color="inherit"
  //           size="small"
  //           onClick={() => {
  //             // const { selectedRow } = this.state;
  //             this.props.closeSnackbar();
  //             instance
  //               .post(URL, data)
  //               .then((result) => {})
  //               .catch((error) => {
  //                 const CommonError = error.response
  //                   ? error.response.data.error.message
  //                   : error.message;
  //                 this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //               });
  //           }}
  //         >
  //           Yes
  //         </Button>,
  //         <Button
  //           key="key"
  //           color="inherit"
  //           size="small"
  //           onClick={() =>
  //             this.setState({ createmenu: false }, () =>
  //               this.props.closeSnackbar(),
  //             )
  //           }
  //         >
  //           No
  //         </Button>,
  //       ],
  //     },
  //   );
  // }

  getData = (item, isRefresh = true) => {
    const { previouscard, carddata, selectedPipelineName } = this.state;
    const windowurl = window.location.pathname.split("/");
    const tabpipelineid = windowurl[windowurl.length - 1];
    if (
      isRefresh ||
      item.displayvalue != (previouscard && previouscard.displayvalue)
    ) {
      const data = {
        isrecruiter: this.props.isrecruiter,
        ishiringowner: this.props.ishiringowner,
        ishiringmanager: this.props.ishiringmanager,
        isparticipant: this.props.isparticipant,
        pipelineid: (carddata && carddata.displayvalue) || tabpipelineid,
        // pipelineid: carddata && carddata.displayvalue,
      };
      instance
        .post("recruit/getpipeline", data)
        .then((result) => {
          const candidateList = result.data.result[0].candidate || [];
          const pipelineList =
            (result.data.result[0] &&
              result.data.result[0].candidate.length > 0 &&
              result.data.result[0].pipelinestage.map((element) => {
                element.hidden = false;
                if (
                  element.stagecategoryid == 5 ||
                  element.stagecategoryid == 6
                ) {
                  element.hidden = true;
                }
                element.data = result.data.result[0].candidate.filter(
                  (x) =>
                    x.pipelinestageid == element.pipelinestageid ||
                    (element.stagecategoryid == 1 &&
                      x.candidatestageid == null),
                );
                // element.data = result.data.result[0].candidate;
                element.count = element.data.length;
                return element;
              })) ||
            (result.data.result[0] &&
              result.data.result[0].pipelinestage.map((element) => {
                element.count = 0;
                element.hidden = false;
                if (
                  element.stagecategoryid == 5 ||
                  element.stagecategoryid == 6
                ) {
                  element.hidden = true;
                }
                return element;
              })) ||
            [];

          // const carddata1 = this.state.hiringPipelines.filter(
          //   (x) => x.displayvalue == tabpipelineid,
          // );

          const pipelinestagelist =
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].pipelinestage &&
            result.data.result[0].pipelinestage.map((x) => ({
              ...x,
              displayname: x.stagename,
              displayvalue: x.pipelinestageid,
            }));
          this.setState({
            pipelineList,
            previouscard: item,
            pipelinestagelist,
            pageloading: false,
            candidateList,
            tabpipelineid,
            selectedPipelineName: item,
          });
        })
        .catch((error) => {
          this.setState({ pageloading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  backtomainPage() {
    this.setState(
      {
        viewDetails: false,
        viewResume: false,
        viewCoverLetter: false,
      },
      () =>
        this.props.history.push(
          `${this.props.match.path}/pipeline/${
            this.state.carddata
              ? this.state.carddata.displayvalue
              : this.state.tabpipelineid
          }`,
        ),
    );
  }

  render() {
    const {
      open,
      isSingle,
      isBulk,
      hiringPipelines = [],
      pipelineList,
      carddata,
      tabpipelineid,
      pipelinestageid,
      pipelinestagelist = [],
    } = this.state;
    const { classes } = this.props;
    const { anchorEl, tabId } = this.state;
    return (
      <div className="innerwrapper-full-width">
        <Helmet>
          <title>{headersList.Recruit.Pipeline.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div className="content-outer-wrapper-with-tab">
            {this.state.viewDetails ? (
              <CandidateDetails
                viewDetails={this.state.viewDetails}
                viewResume={this.state.viewResume}
                viewCoverLetter={this.state.viewCoverLetter}
                backtomainPage={this.backtomainPage}
                candidateid={this.state.candidateid}
                candidateempid={this.state.candidateempid}
                candidatename={this.state.candidatename}
                candidatedesignation={this.state.designationname}
                pipelinestageid={this.state.pipelinestageid}
                isfavorite={this.state.isfavorite}
                stagename={this.state.stagename}
                selectedrow={this.state.selectedrow}
                tabpipelineid={this.state.tabpipelineid}
                {...this.state}
                {...this.props}
              />
            ) : (
              <div>
                <Grid container spacing={3}>
                  <Grid item md={4} sm={12}>
                    <div className="display-flex">
                      <p className="large-text-dark-secondary t-bold margin-top-4 ellipsis">
                        {this.state.carddata
                          ? this.state.carddata.displayname
                          : this.state.selectedPipelineName &&
                            this.state.selectedPipelineName[0]
                          ? this.state.selectedPipelineName[0].displayname
                          : "Select pipeline"}
                      </p>
                      <div
                        className="margin-left-16 cursor-pointer"
                        onClick={this.onSortMenuClick}
                      >
                        <div className="payroll-option">
                          <img src={menuicon}></img>
                          <img src={downArrow} className="margin-left-16"></img>
                        </div>
                        <Popover
                          open={this.state.sortmenu}
                          anchorEl={this.state.sort_anchorEl}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          onClick={() => this.setState({ sortmenu: false })}
                          className="margin-top-8"
                        >
                          <Paper style={{ width: 200 }}>
                            <div>
                              <MenuList>
                                {hiringPipelines.map((x) => (
                                  <ListItem
                                    button
                                    className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                    onClick={() =>
                                      this.setState({ carddata: x }, () => {
                                        this.getData(x);
                                        this.props.history.push(
                                          `${this.props.match.path}/pipeline/${x.displayvalue}`,
                                        );
                                      })
                                    }
                                  >
                                    <ListItemText style={{ padding: 0 }}>
                                      <span className="small-dark-secondary">
                                        {x.displayname}
                                      </span>
                                    </ListItemText>
                                  </ListItem>
                                ))}
                              </MenuList>
                            </div>
                          </Paper>
                        </Popover>
                      </div>
                    </div>
                  </Grid>
                  <Grid item md={8} sm={12}>
                    <div>
                      <SearchSq
                        placeholder="Search by candidate name, position"
                        value={this.state.searchValue}
                        disabled={!pipelineList}
                        onChange={this.handleSearch}
                      />
                    </div>
                  </Grid>
                </Grid>

                {this.state.carddata || this.state.tabpipelineid ? (
                  <Grid
                    container
                    className="margin-top-24 position-rel thin-scroll thin-scroll2 "
                    style={{
                      overflowX: "auto",
                      overflowY: "auto",
                      height: "68vh",
                      paddingBottom: 24,
                      paddingRight: 24,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      {this.state.pageloading ? (
                        <img className="loader" src={loader} />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          {pipelineList && (
                            <DragDropContext
                              onDragEnd={(e) => this.onDrag({ ...e })}
                            >
                              {pipelineList
                                // .filter((x) => x.hidden == false)
                                .map((x, idx) => (
                                  <Droppable
                                    droppableId={`droppable_${idx}_${x.pipelinestageid}`}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        // style={getListStyle(snapshot.isDraggingOver)}
                                        style={{ padding: 8, width: 240 }}
                                        {...provided.draggableProps}
                                      >
                                        <div className="margin-bottom-16">
                                          <Tooltip
                                            title={x.stagename}
                                            placement="top"
                                          >
                                            <p className="normal-dark-secondary t-bold floatleft width70 ellipsis">
                                              {x.stagename}
                                            </p>
                                          </Tooltip>
                                          <div className="floatright">
                                            <img
                                              src={kebabIcon}
                                              className="margin-right-16"
                                              onClick={(e) =>
                                                this.menuOptionsClick(e, x)
                                              }
                                            ></img>
                                            {(this.props.isrecruiter ||
                                              this.props.ishiringowner ||
                                              this.props.ishiringmanager) && (
                                              <img
                                                src={addPlusIcon}
                                                onClick={(event) =>
                                                  this.onAddClick(event, x)
                                                }
                                              ></img>
                                            )}
                                            <Popover
                                              open={this.state.addclick}
                                              anchorEl={this.state.add_anchorEl}
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "right",
                                              }}
                                              transformOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                              }}
                                              onClose={() =>
                                                this.setState({
                                                  addclick: false,
                                                })
                                              }
                                              className="margin-top-8"
                                            >
                                              <Paper style={{ width: 180 }}>
                                                <div>
                                                  <List>
                                                    <ListItem
                                                      button
                                                      className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                                      onClick={this.toggleDrawer(
                                                        "right",
                                                        true,
                                                        "isSingle",
                                                      )}
                                                    >
                                                      <ListItemIcon>
                                                        <img
                                                          src={independenticon}
                                                        ></img>
                                                      </ListItemIcon>
                                                      <ListItemText
                                                        style={{ padding: 0 }}
                                                      >
                                                        <span className="small-dark-secondary">
                                                          New application
                                                        </span>
                                                      </ListItemText>
                                                    </ListItem>
                                                    <ListItem
                                                      button
                                                      className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                                      onClick={this.toggleDrawer(
                                                        "right",
                                                        true,
                                                        "isBulk",
                                                      )}
                                                    >
                                                      <ListItemIcon>
                                                        <img
                                                          src={teamicon}
                                                        ></img>
                                                      </ListItemIcon>
                                                      <ListItemText
                                                        style={{ padding: 0 }}
                                                      >
                                                        <span className="small-dark-secondary">
                                                          Bulk upload
                                                        </span>
                                                      </ListItemText>
                                                    </ListItem>
                                                  </List>
                                                </div>
                                              </Paper>
                                            </Popover>
                                          </div>
                                          <div className="clear-float"></div>
                                        </div>
                                        <div
                                          style={{
                                            marginBottom: 16,
                                            borderBottom: "1px dashed #d9dadb",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: 12,
                                              borderRadius: 4,
                                              backgroundColor:
                                                x.stagecategoryid == 1
                                                  ? "#d5b8ff"
                                                  : x.stagecategoryid == 2
                                                  ? "#fffcd1"
                                                  : x.stagecategoryid == 3
                                                  ? "#d9fdfd"
                                                  : x.stagecategoryid == 4
                                                  ? "#d8fbdf"
                                                  : x.stagecategoryid == 5
                                                  ? "#fadcdd"
                                                  : "#82bdf9",
                                              padding: "6px 16px",
                                              fontWeight: "bold",
                                              display: "inline-block",
                                              marginBottom: 16,
                                              color: "#292929",
                                            }}
                                          >
                                            {x.stagecategoryid == 1
                                              ? "New"
                                              : x.stagecategoryid == 2
                                              ? "Screening"
                                              : x.stagecategoryid == 3
                                              ? "Interviewing"
                                              : x.stagecategoryid == 4
                                              ? "Offered"
                                              : x.stagecategoryid == 5
                                              ? "Disqualify"
                                              : "Hired"}
                                          </span>
                                          <span className="small-dark-secondary floatright margin-top-4">
                                            Count: <strong>{x.count}</strong>
                                          </span>
                                          <span className="clear-float"></span>
                                        </div>
                                        {x.data &&
                                          x.data.map((item, index) => (
                                            <Draggable
                                              key={index}
                                              draggableId={`${item.name}_${index}_${item.candidateid}`}
                                              index={index}
                                              // isDragging={false}
                                              // isDragDisabled={
                                              //   item.stagecategoryid == 1 ||
                                              //     item.stagecategoryid == 5 ||
                                              //     item.stagecategoryid == 6
                                              //     ? true
                                              //     : false
                                              // }
                                              isDragDisabled={
                                                item.candidateempid != null
                                                  ? true
                                                  : false
                                              }
                                            >
                                              {(provided, snapshot) => (
                                                <Paper
                                                  className="rounded-rectangle-paper padding8 position-rel pipeline-card margin-bottom-8"
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  ref={provided.innerRef}
                                                  onClick={() =>
                                                    this.setState(
                                                      {
                                                        candidateid:
                                                          item.candidateid,
                                                        candidatename:
                                                          item.name,
                                                        candidateempid:
                                                          item.candidateempid,
                                                        isfavorite:
                                                          item.isfavorite,
                                                        candidatedesignation:
                                                          item.designationname,
                                                        viewDetails: true,
                                                        pipelinestageid:
                                                          x.pipelinestageid,
                                                        stagename: x.stagename,
                                                        selectedrow: item,
                                                        tabpipelineid:
                                                          this.state
                                                            .tabpipelineid,
                                                      },
                                                      // () =>
                                                      //   this.props.history.push(
                                                      //     `${
                                                      //       this.props.match.path
                                                      //     }/pipeline/${
                                                      //       this.state.carddata
                                                      //         ? this.state
                                                      //             .carddata
                                                      //             .displayvalue
                                                      //         : tabpipelineid
                                                      //     }/${item.candidateid}`,
                                                      //   ),
                                                    )
                                                  }
                                                  // style={
                                                  //   item.candidateempid == null
                                                  //     ? { cursor: "grab" }
                                                  //     : { cursor: "pointer" }
                                                  // }
                                                >
                                                  {/* <Link
                                                  to={{
                                                    pathname: `${
                                                      this.props.match.path
                                                    }/pipeline/${
                                                      this.state.carddata
                                                        ? this.state.carddata
                                                            .displayvalue
                                                        : tabpipelineid
                                                    }`,
                                                    hash: `${item.candidateid}`,
                                                  }}
                                                  target="_self"
                                                > */}
                                                  <div>
                                                    <div
                                                      className="display-flex margin-bottom-8"
                                                      style={{
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <img
                                                        src={getFormattedImageLink(
                                                          item.profilepicpath,
                                                        )}
                                                        height="24"
                                                        style={{
                                                          borderRadius: 16,
                                                          width: 24,
                                                          objectFit: "cover",
                                                        }}
                                                      />
                                                      <Tooltip
                                                        title={item.name}
                                                        placement="top"
                                                      >
                                                        <p
                                                          className="small-dark-secondary t-bold ellipsis margin-left-8 margin-right-8"
                                                          style={{
                                                            maxWidth: "40%",
                                                          }}
                                                        >
                                                          {item.name}
                                                        </p>
                                                      </Tooltip>
                                                      {item.avgfeedback > 0 && (
                                                        <p className="extra-small-dark-disabled t-bold margin-right-4">
                                                          {item.avgfeedback}
                                                        </p>
                                                      )}
                                                      {item.avgfeedback > 0 && (
                                                        <img
                                                          src={starIcon}
                                                        ></img>
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        right: 3,
                                                        top: 4,
                                                      }}
                                                    >
                                                      <img
                                                        src={
                                                          item.isfavorite ==
                                                          true
                                                            ? favblackIcon
                                                            : favOutline
                                                        }
                                                        className="floatleft margin-right-4 padding-top-8 padding-bottom-8"
                                                      ></img>
                                                      {/* {x.ishiringmanager && ( */}
                                                      <img
                                                        src={kebabIcon}
                                                        className="floatleft padding8 cursor-pointer"
                                                        // onClick={() =>
                                                        //   this.setState(
                                                        //     {
                                                        //       pipelinestage:
                                                        //         x.pipelinestageid,
                                                        //     },
                                                        //     () => (e) =>
                                                        //       this.moreOptionsClick(
                                                        //         e,
                                                        //         item,
                                                        //         x.pipelinestageid,
                                                        //       ),
                                                        //   )
                                                        // }
                                                        onClick={(e) =>
                                                          this.moreOptionsClick(
                                                            e,
                                                            item,
                                                            x.pipelinestageid,
                                                          )
                                                        }
                                                      ></img>
                                                      {/* )} */}
                                                      <div className="clear-float"></div>
                                                    </div>

                                                    <span>
                                                      <div
                                                        className="display-flex margin-bottom-8"
                                                        style={{
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <IconLabel
                                                          label={
                                                            item.designationname
                                                          }
                                                          img={designationIcon}
                                                        />
                                                        <Tooltip
                                                          title={
                                                            item.priorityid == 1
                                                              ? "High priority"
                                                              : item.priorityid ==
                                                                2
                                                              ? "Medium priority"
                                                              : "Low priority"
                                                          }
                                                          placement="top"
                                                        >
                                                          <img
                                                            src={
                                                              item.priorityid ==
                                                              1
                                                                ? priorityHighIcon
                                                                : item.priorityid ==
                                                                  2
                                                                ? priorityMedIcon
                                                                : priorityLowIcon
                                                            }
                                                            className="margin-left-8"
                                                          ></img>
                                                        </Tooltip>
                                                      </div>
                                                      <IconLabel
                                                        label={`${
                                                          item.currencycode
                                                        } ${
                                                          item.expectedsalary
                                                        } ${
                                                          item.expectedsalary >
                                                          item.maxbudget
                                                            ? "👎 "
                                                            : "👍 "
                                                        }`}
                                                        img={salaryIcon}
                                                        className="margin-bottom-8"
                                                      />

                                                      <IconLabel
                                                        label={`${
                                                          item.noticeperiod
                                                            ? `${item.noticeperiod} days`
                                                            : `${item.noticeperiod} day`
                                                        } notice`}
                                                        img={calenderIcon}
                                                        className="margin-bottom-8"
                                                      />
                                                    </span>
                                                    <div
                                                      className="display-flex"
                                                      style={{
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="show-options display-flex">
                                                        <span className="extra-small-dark-disabled applied-on">
                                                          Applied on{" "}
                                                          {item.applicationdate}
                                                        </span>
                                                        <div
                                                          className="view-resume"
                                                          onClick={() =>
                                                            this.setState({
                                                              viewDetails: true,
                                                              viewResume: true,
                                                              viewCoverLetter: false,
                                                            })
                                                          }
                                                        >
                                                          <img
                                                            src={documentIcon}
                                                          ></img>
                                                          <span
                                                            className="extra-small-blue"
                                                            style={{
                                                              fontSize: 11,
                                                            }}
                                                          >
                                                            View resume
                                                          </span>
                                                        </div>
                                                        <div
                                                          className="view-cover-letter"
                                                          onClick={() =>
                                                            this.setState({
                                                              viewDetails: true,
                                                              viewResume: false,
                                                              viewCoverLetter: true,
                                                            })
                                                          }
                                                        >
                                                          <img
                                                            src={newsLetterIcon}
                                                          ></img>
                                                          <span
                                                            className="extra-small-blue"
                                                            style={{
                                                              fontSize: 11,
                                                            }}
                                                          >
                                                            View cover letter
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <Tooltip
                                                        title="New updates!"
                                                        placement="top-start"
                                                      >
                                                        <span
                                                          className="activity-details"
                                                          onClick={(e) =>
                                                            this.openActivity(
                                                              e,
                                                              item,
                                                            )
                                                          }
                                                          style={
                                                            item.activitycount
                                                              ? {
                                                                  cursor:
                                                                    "pointer",
                                                                }
                                                              : {
                                                                  pointerEvents:
                                                                    "none",
                                                                }
                                                          }
                                                        >
                                                          <img
                                                            src={activityIcon}
                                                            className="vertical-middle inline-block margin-right-8"
                                                          ></img>
                                                          <p className="extra-small-dark inline-block">
                                                            {item.activitycount}
                                                          </p>
                                                        </span>
                                                      </Tooltip>
                                                    </div>

                                                    <div className="clear-float"></div>
                                                  </div>
                                                  {/* </Link> */}
                                                </Paper>
                                              )}
                                            </Draggable>
                                          ))}
                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                ))}
                            </DragDropContext>
                          )}
                        </div>
                      )}

                      {/* don't delete hide stage code
                    {pipelineList &&
                      pipelineList
                        .filter((x) => x.hidden == true)
                        .map((x, idx) => (
                          <div style={{ padding: 8, width: 240 }}>
                            <div className="margin-bottom-16">
                              <p className="normal-dark-secondary t-bold floatleft">
                                {x.stagename}
                              </p>
                              <div className="floatright">
                                <img
                                  src={kebabIcon}
                                  className="margin-right-16"
                                  onClick={this.menuOptionsClick}
                                ></img>

                                <img
                                  src={addPlusIcon}
                                  onClick={(event) => this.onAddClick(event)}
                                ></img>
                              </div>
                              <div className="clear-float"></div>
                            </div>
                            <div
                              style={{
                                marginBottom: 16,
                                borderBottom: "1px dashed #d9dadb",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 12,
                                  borderRadius: 4,
                                  backgroundColor: "#cccccc",
                                  padding: "6px 16px",
                                  fontWeight: "bold",
                                  display: "inline-block",
                                  marginBottom: 16,
                                  color: "#292929",
                                }}
                              >
                                {x.stagename}
                              </span>
                              <span className="small-dark-secondary floatright margin-top-4">
                                Count: <strong>{x.count}</strong>
                              </span>
                              <span className="clear-float"></span>
                            </div>
                          </div>
                        ))} */}

                      <Popover
                        open={this.state.moreOptions}
                        anchorEl={this.state.moreOptions_anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        onClose={() => this.setState({ moreOptions: false })}
                        className="margin-top-8"
                      >
                        <Paper style={{ width: 200 }}>
                          <div>
                            <MenuList>
                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onClick={() => this.markandunmarkFav()}
                                disabled={this.state.isDisableSaveButton}
                                // style={
                                //   item.candidateempid != null
                                //     ? { pointerEvents: "none" }
                                //     : {}
                                // }
                              >
                                <ListItemIcon>
                                  <img
                                    src={
                                      this.state.selectedrow &&
                                      this.state.selectedrow.isfavorite == false
                                        ? favblackIcon
                                        : favOutline
                                    }
                                  ></img>
                                </ListItemIcon>

                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    {this.state.selectedrow &&
                                    this.state.selectedrow.isfavorite == false
                                      ? "Mark as favorite"
                                      : "Unmark as favorite"}
                                  </span>
                                </ListItemText>
                              </ListItem>

                              {/* <ListItem
                              button
                              className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            // onClick={() => this.handleClick(2, "Department")}
                            >
                              <ListItemIcon>
                                <img src={favOutline}></img>
                              </ListItemIcon>
                              <ListItemText style={{ padding: 0 }}>
                                <span className="small-dark-secondary">
                                  Unmark as favorite
                              </span>
                              </ListItemText>
                            </ListItem> */}

                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onClick={(e) =>
                                  this.openActivity(e, this.state.selectedrow)
                                }
                              >
                                <ListItemIcon>
                                  <img src={activityIcon}></img>
                                </ListItemIcon>
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    View activity
                                  </span>
                                </ListItemText>
                              </ListItem>
                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onClick={() =>
                                  this.setState({
                                    candidateid:
                                      this.state.selectedrow.candidateid,
                                    viewDetails: true,
                                    pipelinestageid:
                                      this.state.selectedrow.pipelinestageid,
                                    moreOptions: false,
                                  })
                                }
                              >
                                <ListItemIcon>
                                  <img src={previewIcon}></img>
                                </ListItemIcon>
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    View details
                                  </span>
                                </ListItemText>
                              </ListItem>
                              {/* <ListItem
                              button
                              className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                              // onClick={() => this.handleClick(2, "Department")}
                            >
                              <ListItemIcon>
                                <img src={copyIcon}></img>
                              </ListItemIcon>
                              <ListItemText style={{ padding: 0 }}>
                                <span className="small-dark-secondary">
                                  Copy job URL
                                </span>
                              </ListItemText>
                            </ListItem>
                            <ListItem
                              button
                              className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                              // onClick={() => this.handleClick(2, "Department")}
                            >
                              <ListItemIcon>
                                <img src={moveIcon}></img>
                              </ListItemIcon>
                              <ListItemText style={{ padding: 0 }}>
                                <span className="small-dark-secondary">
                                  Move to…
                                </span>
                              </ListItemText>
                            </ListItem> */}
                            </MenuList>
                          </div>
                        </Paper>
                      </Popover>
                      <div>
                        <Popover
                          open={this.state.menuOptions}
                          anchorEl={this.state.menuOptions_anchorEl}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          onClose={() => this.setState({ menuOptions: false })}
                          className="margin-top-8"
                        >
                          <Paper style={{ width: 180 }}>
                            <MenuList>
                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onClick={this.handleClick}
                                aria-haspopup="true"
                                aria-owns={open ? "simple-menu" : null}
                                aria-controls="simple-menu"
                              >
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    Sort
                                  </span>
                                </ListItemText>
                                <ListItemSecondaryAction>
                                  <img
                                    src={rightArrow}
                                    className="vertical-middle"
                                  />
                                </ListItemSecondaryAction>
                              </ListItem>
                              {/* <ListItem
                              button
                              className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                              onClick={() => this.hideStage()}
                            >
                              <ListItemText style={{ padding: 0 }}>
                                <span className="small-dark-secondary">
                                  Hide stage
                                </span>
                              </ListItemText>
                            </ListItem> */}
                            </MenuList>
                          </Paper>
                        </Popover>

                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={this.handleClose}
                          anchorPosition={{ top: 0, left: 0 }}
                          anchorReference="anchorEl"
                        >
                          <MenuItem
                            onClick={() =>
                              this.Sortable(
                                this.state.selectedpipelinestage,
                                "name",
                                "asc",
                              )
                            }
                          >
                            Candidate name (A-Z)
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              this.Sortable(
                                this.state.selectedpipelinestage,
                                "name",
                                "desc",
                              )
                            }
                          >
                            Candidate name (Z-A)
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              this.Sortable(
                                this.state.selectedpipelinestage,
                                "applicationdate",
                                "asc",
                              )
                            }
                          >
                            Date of application (A-Z)
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              this.Sortable(
                                this.state.selectedpipelinestage,
                                "applicationdate",
                                "desc",
                              )
                            }
                          >
                            Date of application (Z-A)
                          </MenuItem>
                        </Menu>
                      </div>
                      <Activity
                        {...this.state}
                        {...this.props}
                        closeActivity={this.closeActivity}
                        getData={this.getData}
                        classes={classes}
                      />
                      {/* <Popover
                    open={this.state.activityFlag}
                    anchorEl={this.state.activity_anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    onClick={() => this.setState({ activityFlag: false })}
                    className="margin-top-8"
                  >
                    <div style={{ width: 368, padding: 24 }}>
                      <div className="margin-bottom-16">
                        <p className="small-dark t-bold floatleft">
                          Activities
                        </p>
                        <p
                          className="small-blue t-bold floatright cursor-pointer"
                          onClick={() => this.setState({ drawerOpen: true })}
                        >
                          + Schedule activity
                        </p>
                        <div className="clear-float"></div>
                      </div>

                      <div className="display-flex">
                        <div>
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: this.state.checked,
                              placeholder: "",
                              label: "",
                            })}
                            onChange={(value) => {
                              this.handleChange(value, "checked");
                            }}
                          />
                        </div>
                        <div>
                          <span>
                            <IconLabel
                              label="Applied on 25th October 2019"
                              img={userIcon}
                              labelClassNames="t-14 t-bold"
                              className="margin-bottom-8"
                            />
                            <IconLabel
                              label="Applied on 25th October 2019"
                              img={calenderIcon}
                              className="margin-bottom-8"
                            />
                            <IconLabel
                              label="Nikhil and 3 others"
                              img={dependentIcon}
                              className="margin-bottom-8"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Popover> */}
                    </div>
                  </Grid>
                ) : (
                  <div className="position-rel">
                    <DefaultComp
                      heading="There is no pipeline selected"
                      subheading="Please select pipeline"
                      imageSrc={empty}
                    />
                  </div>
                )}
              </div>
            )}

            <Drawer
              anchor="right"
              open={this.state.right}
              // onClose={this.toggleDrawer("right", false)}
              onClose={() => this.CloseDrawer(COMPONENT_CONTEXT.PARENT)}
              classes={{
                paper: "width30 planner-drawer padding15",
              }}
            >
              <DrawerHeader
                header={
                  isSingle
                    ? `Add new application`
                    : `Upload bulk application ${
                        pipelinestageid
                          ? `(${
                              pipelinestagelist.find(
                                (objStage) =>
                                  objStage.displayvalue == pipelinestageid,
                              ).displayname
                            })`
                          : ``
                      }`
                }
                isbackarrow={false}
                closeDrawer={() => this.CloseDrawer(COMPONENT_CONTEXT.PARENT)}
              />
              {/* <CandidateDetails
            {...this.state}
            pipelinestageid = {this.state.pipelinestageid}

            /> */}
              {isSingle && (
                <Addapplication
                  isSingle={isSingle}
                  {...this.state}
                  toggleDrawer={this.toggleDrawer}
                  CloseDrawer={this.CloseDrawer}
                  getData={this.getData}
                  tabpipelineid={
                    this.state.tabpipelineid && this.state.tabpipelineid
                  }
                />
              )}
              {isBulk && (
                <Uploadapplication
                  isBulk={this.state.isBulk}
                  toggleDrawer={this.toggleDrawer}
                  CloseDrawer={this.CloseDrawer}
                  getData={this.getData}
                  setDeleteFile={this.setDeleteFile.bind(this)}
                  tabpipelineid={
                    this.state.tabpipelineid && this.state.tabpipelineid
                  }
                  {...this.state}
                />
              )}
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
